export default "__VITE_ASSET__B9zzDKZ3__"